<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Danh sách kho hàng
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="messError">
                        <span>{{messError}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                            <div class="col-sm-11 d-flex flex-column">
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.warehouse_name.label"
                                                :id="dataSearch.warehouse_name.id"
                                                :placeholder="dataSearch.warehouse_name.placeholder"
                                                :value-default="dataSearch.warehouse_name.value"
                                                @inputValue="onChange($event, dataSearch.warehouse_name.id)"
                                                :required="dataSearch.warehouse_name.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.warehouse_code.label"
                                                :id="dataSearch.warehouse_code.id"
                                                :placeholder="dataSearch.warehouse_code.placeholder"
                                                :value-default="dataSearch.warehouse_code.value"
                                                @inputValue="onChange($event, dataSearch.warehouse_code.id)"
                                                :required="dataSearch.warehouse_code.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.warehouse_addr.label"
                                                :id="dataSearch.warehouse_addr.id"
                                                :placeholder="dataSearch.warehouse_addr.placeholder"
                                                :value-default="dataSearch.warehouse_addr.value"
                                                @inputValue="onChange($event, dataSearch.warehouse_addr.id)"
                                                :required="dataSearch.warehouse_addr.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                                <div class="col-sm-12 d-flex gap-5 flex-wrap">
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.warehouse_phone.label"
                                                :id="dataSearch.warehouse_phone.id"
                                                :placeholder="dataSearch.warehouse_phone.placeholder"
                                                :value-default="dataSearch.warehouse_phone.value"
                                                @inputValue="onChange($event, dataSearch.warehouse_phone.id)"
                                                :required="dataSearch.warehouse_phone.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.product_name.label"
                                                :id="dataSearch.product_name.id"
                                                :placeholder="dataSearch.product_name.placeholder"
                                                :value-default="dataSearch.product_name.value"
                                                @inputValue="onChange($event, dataSearch.product_name.id)"
                                                :required="dataSearch.product_name.required"
                                        ></InputTextNormal>
                                    </div>
                                    <div class="col-sm-3">
                                        <InputTextNormal
                                                :label="dataSearch.product_code.label"
                                                :id="dataSearch.product_code.id"
                                                :placeholder="dataSearch.product_code.placeholder"
                                                :value-default="dataSearch.product_code.value"
                                                @inputValue="onChange($event, dataSearch.product_code.id)"
                                                :required="dataSearch.product_code.required"
                                        ></InputTextNormal>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-1 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSearch" @click="searchInventory"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 d-flex justify-content-between mt-4">
                        <div class="action d-flex align-items-center gap-3">
                            <div class="total">
                                {{ CommonText.TOTAL_RECORD(listInventories.length, paginate.itemCount) }}
                            </div>
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectAction.label"
                                        :id="selectAction.id"
                                        :placeholder="selectAction.placeholder"
                                        :value-default="selectAction.value"
                                        :required="selectAction.required"
                                        :options="selectAction.options"
                                        @action="actionSelect($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                        <div class="action-left d-flex align-items-center gap-3">
                            <div class="dropdown-action">
                                <SelectCustom
                                        :label="selectLimitPage.label"
                                        :id="selectLimitPage.id"
                                        :placeholder="selectLimitPage.placeholder"
                                        :value-default="selectLimitPage.value"
                                        :required="selectLimitPage.required"
                                        :options="selectLimitPage.options"
                                        @action="actionLimitPage($event)"
                                ></SelectCustom>
                            </div>
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <table class="table">
                            <thead>
                            <tr>
                                <th scope="col" style="width: 2%;"><InputCheckboxOne id="select_all" :value-default="checkAll" @inputValue="onChangeSelectAll($event)" :checked="checkAll"></InputCheckboxOne></th>
                                <th scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-if="listInventories.length > 0" v-for="inventory in listInventories" :key="inventory.id">
                                <td><InputCheckboxOne :id="inventory.id" :value-default="checkItems[inventory.id]" @inputValue="onChangeSelectItem($event, inventory.id)" :checked="checkItems[inventory.id]"></InputCheckboxOne></td>
                                <td class="product-name">{{inventory.warehouse.name}}</td>
                                <td>{{inventory.warehouse.code}}</td>
                                <td>{{inventory.product.product_name}}</td>
                                <td>{{inventory.product.product_code}}</td>
                                <td>{{inventory.quantity}}</td>
                                <td>{{inventory.awaiting_shipment_qty}}</td>
                            </tr>
                            <tr v-else>
                                <td colspan="8" class="text-center">Không có dữ lệu được tìm thấy!</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <PaginateComponent v-if="listInventories.length > 0 && paginate.pageCount > 1" :paginate="paginate" :urlOrigin="urlOrigin" @page="emitPage($event)"></PaginateComponent>
                </div>
            </div>
        </div>
    </div>
</div>
<LoadingComponent v-if="isLoading"></LoadingComponent>

